import type { PrescriptionsConfig, SubscriptionsConfig } from '@grandvisionhq/fun-my-account'
import type { IntlContextModel } from '@grandvisionhq/state'

export const getSubscriptionsConfig = (intl: IntlContextModel): SubscriptionsConfig => {
  const { getLabel } = intl
  const subscriptionProductFacetId = 'isAvailableForSubscription'

  const usps = [
    getLabel('account.subscriptions.usp1', {
      hideLabelKey: true,
    }),
    getLabel('account.subscriptions.usp2', {
      hideLabelKey: true,
    }),
    getLabel('account.subscriptions.usp3', {
      hideLabelKey: true,
    }),
    getLabel('account.subscriptions.usp4', {
      hideLabelKey: true,
    }),
  ]

  return {
    subscriptionProductFacetId,
    usps,
  }
}

export const getPrescriptionsConfig = (): PrescriptionsConfig => {
  return {
    daysOverdueThreshold: 730,
  }
}
